import SimpleLightbox from "simplelightbox";
import domready from 'domready';

domready(() => {
    new SimpleLightbox('.lightbox', { /* options */ });
});
